import { ErrorBoundary } from './ErrorBoundary'
export { ErrorPage } from './ErrorPage'
export default ErrorBoundary
